'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToastContainerContextProvider: function() {
        return ToastContainerContextProvider;
    },
    useToastContainerContext: function() {
        return useToastContainerContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const toastContainerContextDefaultValue = {
    close: ()=>null,
    intent: undefined,
    bodyId: '',
    titleId: ''
};
const ToastContainerContext = /*#__PURE__*/ _react.createContext(undefined);
const ToastContainerContextProvider = ToastContainerContext.Provider;
const useToastContainerContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(ToastContainerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : toastContainerContextDefaultValue;
};
